import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteName, siteDescription, contactInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-closed-captioning-fill text-2xl text-accent-400"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">{siteDescription}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">关于我们</Link></li>
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">{cat.name}（{cat.articleCount}篇）</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-accent-400"></i>
                </span>
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-wechat-line text-accent-400"></i>
                </span>
                <span>微信：{contactInfo.wechat}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-accent-400"></i>
                </span>
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">&copy; {new Date().getFullYear()} {siteName}. All Rights Reserved. 专注中文字幕 日韩影视资源导航</p>
          <div className="flex items-center gap-4 text-background-400">
            <a href="#" className="text-sm hover:text-accent-400 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm hover:text-accent-400 transition-colors duration-200" rel="nofollow">使用条款</a>
            <a href="#" className="text-sm hover:text-accent-400 transition-colors duration-200" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}